import { useShoppingCartsContext } from 'context/ShoppingCartsContext';
import { useNavigate } from 'react-router';
import { tss } from 'tss-react';

import ListItem from 'components/desktop/ShoppingCart/Search/misc/ListItem';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import useTranslation from 'hooks/useTranslation';
import * as Status from 'types/ShoppingCart/Status';

interface IProps {
	status: Status.default;
}

const List = ({ status }: IProps) => {
	const { classes } = useStyles();
	const { t, tl } = useTranslation();
	const carts = useShoppingCartsContext();
	const navigate = useNavigate();

	return (
		<>
			<hr />
			<RenderIf condition={!carts.getByStatus(status).length}>
				<>
					<h3 style={{ fontStyle: 'italic', opacity: '0.5' }}>
						{t('shoppingCart:NO_CART_UNDER_THIS_STATUS')}
					</h3>
				</>
			</RenderIf>
			<RenderIf condition={Boolean(carts.getByStatus(status).length)}>
				<div className={classes.container}>
					{carts.getByStatus(status).map((e, i) => {
						return (
							<ListItem
								key={i}
								cart={e}
								nextStateLabel={Status.getNextLabel(e.status)}
								previousStateLabel={Status.getPrevLabel(e.status)}
								functions={{
									edit: () => {
										navigate('/shoppingCart/detail/' + e.id);
									},
									delete: () => {
										carts.remove(e.id, tl(e.name));
									},
									setToDefault: () => {
										carts.setDefault(e.id);
									},
									moveToNextState: () => {
										carts.moveToNextStatus(e.id, tl(e.name));
									},
									moveToPrevState: () => {
										carts.moveToPrevStatus(e.id);
									},
								}}
							/>
						);
					})}
				</div>
			</RenderIf>
		</>
	);
};

export default List;

export const useStyles = tss.create({
	container: {
		display: 'grid',
		gridTemplateColumns: '1fr 1fr 1fr',
		gap: '10px',
		justifySelf: 'stretch',
		['@media (max-width: 1390px)']: {
			gridTemplateColumns: '1fr 1fr',
		},
		['@media (max-width: 500px)']: {
			gridTemplateColumns: '1fr',
		},
	},
});
